const encodeComponentId = componentId =>
  componentId ? componentId.replace('.', '-') : componentId;

export default encodeComponentId;
